module.exports = __webpack_public_path__ + "media/images/episode4-9fc1ab5dae63b21eb8a3fb67ba9ecae1.jpeg";